{
	"actions": {
		"cancel": "Annulla",
		"change_email": "Cambia email",
		"deactivate": "Disattiva",
		"open_menu": "Azioni sull'utente",
		"reactivate": "Riattiva",
		"remove": "Rimuovi",
		"resend": "Reinvia invito",
		"revoke": "Revoca invito",
		"sending": "Invio in corso…"
	},
	"change_email": {
		"description": "L'invito è stato inviato a {{email}}.",
		"new_email": "Nuova email",
		"sent": "Invito inviato a {{email}}.",
		"submit": "Cambia e invia",
		"supersedes": "Il link inviato all'indirizzo precedente smette subito di funzionare e un nuovo invito parte verso questo indirizzo.",
		"title": "Cambia l'email dell'invito"
	},
	"columns": {
		"actions": "Azioni",
		"email": "Email",
		"invitation": "Invito",
		"last_activity": "Ultima attività",
		"name": "Nome",
		"status": "Stato"
	},
	"deactivate": {
		"confirm": "Disattiva",
		"description": "Le sessioni aperte vengono chiuse e l'accesso alla console resta bloccato finché non lo riattivi.",
		"done": "Account di {{name}} disattivato.",
		"pending": "Disattivazione in corso…",
		"title": "Disattivare {{name}}?"
	},
	"empty": {
		"description": "Nessuno può ancora accedere a questa console. Invita un utente per cominciare.",
		"no_matches_description": "Nessun utente corrisponde alla ricerca o ai filtri attivi.",
		"no_matches_title": "Nessun risultato",
		"title": "Nessun utente"
	},
	"filters": {
		"status": "Stato"
	},
	"invitation": {
		"expired": "Scaduto il {{date}}",
		"expires": "Scade il {{date}}",
		"sent": "Inviato il {{date}}"
	},
	"invite": {
		"action": "Invita utente",
		"description": "Riceverà un'email con un link per scegliere la password e attivare l'accesso alla console.",
		"email": "Email",
		"email_invalid": "Inserisci un indirizzo email valido.",
		"email_placeholder": "nome@azienda.it",
		"email_required": "Inserisci un indirizzo email.",
		"language": "Lingua dell'email",
		"sent": "Invito inviato a {{email}}.",
		"submit": "Invia invito",
		"title": "Invita un utente"
	},
	"never": "Mai",
	"no_value": "Non disponibile",
	"page_title": "Utenti",
	"reactivate": {
		"confirm": "Riattiva",
		"description": "L'accesso alla console torna attivo. Dovrà accedere di nuovo: le sessioni chiuse con la disattivazione non vengono ripristinate.",
		"done": "Account di {{name}} riattivato.",
		"pending": "Riattivazione in corso…",
		"title": "Riattivare {{name}}?"
	},
	"refusals": {
		"already_exists": "Questo indirizzo appartiene già a un utente o ha un invito in attesa.",
		"last_active_operator": "È l'ultimo utente attivo: senza questo account nessuno potrebbe più accedere alla console. Prima invita o riattiva un altro utente.",
		"self_action": "Non puoi farlo sul tuo account. Chiedi a un altro utente di farlo per te."
	},
	"remove": {
		"confirm": "Rimuovi",
		"description": "L'accesso alla console viene revocato per sempre. Le sue azioni restano nel registro di audit. Non si può annullare.",
		"done": "Account di {{name}} rimosso.",
		"pending": "Rimozione in corso…",
		"title": "Rimuovere {{name}}?"
	},
	"resend": {
		"confirm": "Reinvia",
		"description": "Un nuovo link parte verso lo stesso indirizzo. Il link precedente smette subito di funzionare.",
		"done": "Invito reinviato a {{name}}.",
		"pending": "Invio in corso…",
		"title": "Reinviare l'invito a {{name}}?"
	},
	"revoke": {
		"confirm": "Revoca",
		"description": "Il link nell'email smette di funzionare e l'invito sparisce dall'elenco. Potrai invitare di nuovo lo stesso indirizzo in seguito.",
		"done": "Invito a {{name}} revocato.",
		"pending": "Revoca in corso…",
		"title": "Revocare l'invito a {{name}}?"
	},
	"search_placeholder": "Cerca per nome o email",
	"status": {
		"active": "Attivo",
		"disabled": "Disattivato",
		"expired": "Invito scaduto",
		"invited": "Invitato"
	},
	"total_one": "{{count}} utente",
	"total_other": "{{count}} utenti",
	"you": "Tu"
}
